import * as utility from '../misc/utility';
import { Payslip, Remuneration } from '../objects/Payslip';
import { AttendanceList } from '../objects/Attendance';
import { PendingCertification } from '../objects/PendingCertification';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
*/

export class PayrollEndpoint {
    /**
    * 
    * @param {string} url
    * @param {ApiService} api
    */
    constructor(url, api) {
        this._url = url;
        this._api = api;
    }

    getAttendance(meetingId) {
        if (!utility.isGuid(meetingId))
            throw "Invalid parameter, expected GUID";

        var dst = this._url + '/' + encodeURIComponent(meetingId) + '/attendance';
        return this._api.getResponse(dst)
            .then(AttendanceList.fromResponse);
    }

    getMeetingPayroll(meetingId) {
        if (!utility.isGuid(meetingId)) throw "Invalid parameter, expected GUID";

        var dst = this._url + '/' + encodeURIComponent(meetingId);
        return this._api.getResponse(dst)
            .then(x => x.parseListResult(Payslip.mapResponse));
    }

    updateMeetingPayroll(meetingId, cmd) {
        if (!utility.isGuid(meetingId)) throw "Invalid parameter, expected GUID";

        var dst = this._url + '/' + encodeURIComponent(meetingId) + '/update';

        return this._api.postVoid(dst, cmd);
    }

    recallTimereport(meetingId, cmd) {
        if (!utility.isGuid(meetingId)) throw "Invalid parameter, expected GUID";

        let dst = this._url + '/' + encodeURIComponent(meetingId) + '/recalltimereport';

        return this._api.postResponse(dst, cmd).then(x => x.context.getAttendance(x.getResult()));
    }

    reactivateTimereport(meetingId, cmd) {
        if (!utility.isGuid(meetingId)) throw "Invalid parameter, expected GUID";

        let dst = this._url + '/' + encodeURIComponent(meetingId) + '/reactivatetimereport';

        return this._api.postResponse(dst, cmd).then(x => x.context.getAttendance(x.getResult()));
    }

    recallClaim(cmd) {
        let dst = this._url + '/recallclaim';
        return this._api
            .postResponse(dst, cmd)
            .then(x => x.context.getClaim(x.getResult()));
    }

    recallCertification(cmd) {
        let dst = this._url + '/recallcertification';

        return this._api.postResponse(dst, cmd).then(x => {
            let result = new Remuneration(x.getResult());
            result.resolve(x.context);
            return result;
        });
    }

    deleteRemuneration(id) {
        if (!utility.isGuid(id)) throw "Invalid parameter, expected GUID";

        let dst = this._url + '/deleteremuneration';
        
        return this._api.postVoid(dst, { Id: id });
    }

    getPendingCertification() {
        return this._api
            .postResponse(this._url + '/pendingcertification', {})
            .then(PendingCertification.fromResponse);
    }
}
